import { Collection, Node } from '@react-types/shared';
import { getChildNodes } from '@react-stately/collections';

export const filterNodes = <T>(
  collection: Collection<Node<T>>,
  nodes: Iterable<Node<T>>,
  filter: (node: Node<T>) => boolean
): Iterable<Node<T>> =>
  Array.from(nodes).flatMap((node) => {
    if (node.type === 'section' && node.hasChildNodes) {
      const filteredChildNodes = filterNodes(
        collection,
        getChildNodes(node, collection),
        filter
      );
      return [...filteredChildNodes].some((node) => node.type === 'item')
        ? [{ ...node, childNodes: filteredChildNodes }]
        : [];
    } else {
      return node.type !== 'item' || filter(node) ? [node] : [];
    }
  });
